import rmskincareAPI from '../utils/rmskincareAPI'

const courseApi = {
  findCourseById: async (courseId) => {
    let result = await rmskincareAPI.get(`/management/course/${courseId}`)
    return result.data.data
  },

  editCustomerInfoThought: async (courseId, courseCustomerDto) => {
    let result = await rmskincareAPI.post(
      `/management/course/${courseId}/customer`,
      courseCustomerDto
    )
    return result.data.data
  },

  // delete order
  deleteCourse: async (courseId, cashInId) => {
    let result
    if(cashInId == undefined){
      result = await rmskincareAPI.post(
        `/management/course/del?courseId=${courseId}`
      )
    }else{
      result = await rmskincareAPI.post(
        `/management/course/del?courseId=${courseId}&cashInId=${cashInId}`
      )
    }
    return result.data
  },

  // Course Product

  // only one product at a time
  // courseProduct = {
  //   "actualPricePerEach": 0,
  //   "actualPriceTotal": 0,
  //   "amount": 0,
  //   "productId": 0
  // }

  addBatchProduct: async (courseId, courseProductList) => {
    let result = await rmskincareAPI.post(
      `/management/course/product/batch/${courseId}`,
      courseProductList
    )
    return result.data.data
  },

  editProduct: async (courseId, courseProductId, courseProduct) => {
    let result = await rmskincareAPI.put(
      `/management/course/product/${courseId}?courseProductId=${courseProductId}`,
      courseProduct
    )
    return result.data.data
  },

  deleteProduct: async (courseId, courseProductId) => {
    let result = await rmskincareAPI.delete(
      `/management/course/product/${courseId}?courseProductId=${courseProductId}`
    )
    return result.data.data
  },

  // const courseRecordDto = {
  //   "amount": 0,
  //   "comment": "string",
  //   "courseId": 0,
  //   "courseProductId": 0,
  //   "operatorId": 0,
  //   "recordDateTime": "yyyy/MM/dd hh:mm:ss"
  // }
  addCourseRecord: async (
    courseId,
    courseRecordDto,
    employeeId,
    phoneNumber
  ) => {
    let result = await rmskincareAPI.post(
      `/management/course/record/${courseId}?employeeId=${employeeId}&phoneNumber=${phoneNumber}`,
      courseRecordDto
    )
    return result.data.data
  },

  editCourseRecord: async (courseId, index, courseRecordDto) => {
    let result = await rmskincareAPI.put(
      `/management/course/record/${courseId}?index=${index}`,
      courseRecordDto
    )
    return result.data.data
  },

  deleteCourseRecord: async (courseId, index, courseRecordDto) => {
    let result = await rmskincareAPI.delete(
      `/management/course/record/${courseId}?index=${index}`,
      courseRecordDto
    )
    return result.data.data
  },

  // const paymentDto = {
  //   "afterTax": 0,
  //   "amount": 0,
  //   "comment": "string",
  //   "courseId": 0,
  //   "info": "string",
  //   "paymentMethodId": 0,
  //   "recordDateTime": "string",
  //   "tax": 0
  //
  // }
  addCoursePayment: async (courseId, paymentDto) => {
    let result = await rmskincareAPI.post(
      `/management/course/payment/${courseId}`,
      paymentDto
    )
    // console.log(result)
    return result.data.data
  },
  editCourseStatus: async (comment, courseId) => {
    let result = await rmskincareAPI.post(
      `/management/course/status?comment=${comment}&id=${courseId}`,
    )
    // console.log(result)
    return result.data.data
  },

  editCoursePayment: async (courseId, id, paymentDto) => {
    let result = await rmskincareAPI.put(
      `/management/course/payment/${courseId}?id=${id}`,
      paymentDto
    )
    return result.data.data
  },

  deleteCoursePayment: async (courseId, id) => {
    let result = await rmskincareAPI.delete(
      `/management/course/payment/${courseId}?id=${id}`
    )
    return result.data.data
  },

  /* ServiceProgress */
  getServiceListById: async (customerId) => {
    let result = await rmskincareAPI.get(
      `/management/course/customer/${customerId}`
    )
    return result.data.data
  },

  /* refId search */
  getCustomerInfoByRefid: async (refId) => {
    refId = encodeURIComponent(refId)
    let result = await rmskincareAPI.get(
      `/management/course/customer/refid?customerRefId=${refId}`
    )
    return result.data.data
  },  
}

export default courseApi
